import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c9b049e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5c9b049e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b049e",
  null
  
)

export default component.exports